const NATIVE_WINDOW_TYPES = ["assimilation", "assimilated", "native", "NativeWindow", "FinsembleNativeWindow"];
const convertForIcons = (icons) => {
    const arr = (icons ?? []).map(({ src, url }) => {
        return { src: src ?? url };
    });
    if (arr.length > 0) {
        return arr;
    }
};
const convertForImages = (images) => {
    const arr = (images ?? []).map(({ src, url }) => {
        return { src: src ?? url };
    });
    if (arr.length > 0) {
        return arr;
    }
};
export function newAppDEntry({ appId, name, interop, manifest, version, title, tooltip, description, images, icons, contactEmail, supportEmail, publisher, intents, tags, }) {
    const newEntry = {
        appId,
        name,
        type: "web",
        interop,
        title: title ?? manifest?.component?.displayName ?? name ?? appId,
        description,
        version,
        tooltip,
        contactEmail,
        supportEmail,
        publisher,
        icons: convertForIcons(icons),
        screenshots: convertForImages(images),
        hostManifests: {
            Finsemble: manifest,
        },
        categories: tags,
    };
    if (manifest?.window?.url) {
        if (NATIVE_WINDOW_TYPES.includes(manifest?.window?.windowType ?? "")) {
            newEntry.type = "onlineNative";
        }
        else {
            newEntry.type = "web";
        }
        newEntry.details = {
            url: manifest?.window?.url,
        };
    }
    else if (manifest?.window?.path) {
        newEntry.type = "native";
        newEntry.details = {
            path: manifest.window?.path,
            arguments: manifest.window?.arguments,
        };
    }
    else if (manifest?.window?.windowType === "Citrix") {
        newEntry.type = "citrix";
        newEntry.details = {
            alias: manifest.window?.alias,
            arguments: manifest.window?.arguments,
        };
    }
    else if (manifest?.window?.alias || manifest?.window?.arguments) {
        newEntry.type = "native";
        newEntry.details = {
            alias: manifest.window?.alias,
            arguments: manifest.window?.arguments,
        };
    }
    else {
        newEntry.type = "other";
        newEntry.details = {};
    }
    if (intents && intents?.length > 0) {
        newEntry.interop = {
            intents: {
                listensFor: Object.fromEntries(intents?.map(({ name: intentName, displayName, contexts }) => [intentName, { displayName, contexts }])),
            },
        };
    }
    return newEntry;
}
